var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-img',{attrs:{"src":_vm.img,"width":_vm.width,"height":_vm.height,"contain":""}}),_c('change-log-dialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }